export default "/_next/static/images/DecorMatters-Home-Design-App-Hero-Image-5853f3ba0aabf11ca44ad3bd682f3d80.webp";